import { UserOutlined, TeamOutlined, InboxOutlined, DashboardOutlined, DatabaseOutlined, DropboxOutlined, BarChartOutlined, RetweetOutlined, ScissorOutlined, ExportOutlined, AuditOutlined, ToolOutlined, ThunderboltOutlined, ExperimentOutlined, FireOutlined, FallOutlined } from '@ant-design/icons';
import { displayMessage } from '../../helpers/messages';
import EUserTypes from '../../enums/EUserTypes';

export const sideMenuItensIconsStyle = { fontSize: 20 };
export const topMenuItensIconsStyle = { fontSize: 20 };

// Catálogo completo de itens de menu disponíveis no sistema.
// Cada item declara a lista de papéis (códigos de EUserTypes) que podem vê-lo.
// A filtragem por papel é feita em getSideMenuForUser(userType).
const ALL_MENU_ITEMS = [
  {
    key: '/dashboard',
    icon: <DashboardOutlined style={sideMenuItensIconsStyle} />,
    title: 'Dashboard',
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/batches',
    icon: <InboxOutlined style={sideMenuItensIconsStyle} />,
    title: displayMessage('BATCHES'),
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/drums',
    icon: <DatabaseOutlined style={sideMenuItensIconsStyle} />,
    title: 'Tambores',
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/stock',
    icon: <BarChartOutlined style={sideMenuItensIconsStyle} />,
    title: 'Estoque',
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/operations/rc',
    icon: <RetweetOutlined style={sideMenuItensIconsStyle} />,
    title: 'Recarga (RC)',
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/operations/drenagem',
    icon: <ScissorOutlined style={sideMenuItensIconsStyle} />,
    title: 'Descarga',
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/operations/retirada',
    icon: <ExportOutlined style={sideMenuItensIconsStyle} />,
    title: 'Vendas',
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/operations/amarelamento',
    icon: <ThunderboltOutlined style={sideMenuItensIconsStyle} />,
    title: 'Amarelamento',
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/operations/tanque',
    icon: <ExperimentOutlined style={sideMenuItensIconsStyle} />,
    title: 'Tanque',
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/entry',
    icon: <DropboxOutlined style={sideMenuItensIconsStyle} />,
    title: 'Processamento (QR)',
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/clients',
    icon: <TeamOutlined style={sideMenuItensIconsStyle} />,
    title: displayMessage('CLIENTS'),
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/users',
    icon: <UserOutlined style={sideMenuItensIconsStyle} />,
    title: displayMessage('USERS'),
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/temperature',
    icon: <FireOutlined style={sideMenuItensIconsStyle} />,
    title: 'Temperatura',
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/losses',
    icon: <FallOutlined style={sideMenuItensIconsStyle} />,
    title: 'Perdas',
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/audit-logs',
    icon: <AuditOutlined style={sideMenuItensIconsStyle} />,
    title: 'Logs de Auditoria',
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
  {
    key: '/machines',
    icon: <ToolOutlined style={sideMenuItensIconsStyle} />,
    title: 'Máquinas',
    roles: [EUserTypes.PANEL_ADMIN.code],
  },
];

/**
 * Retorna os itens de menu lateral permitidos para o tipo de usuário informado.
 * Centraliza a matriz de acesso do menu (DRY) e garante que cada papel só veja
 * o que tem permissão.
 * @param {number} userType código do tipo de usuário (EUserTypes.*.code)
 */
export const getSideMenuForUser = (userType) => {
  if (userType == null) return [];
  return ALL_MENU_ITEMS.filter(item => item.roles.includes(userType));
};

const menus = {
  // Menus laterais: agora derivados por papel via getSideMenuForUser.
  // Mantido por compatibilidade com componentes que ainda consomem userSideMenuItens (Admin).
  userSideMenuItens: getSideMenuForUser(EUserTypes.PANEL_ADMIN.code),

  // Menus administrativos (vazio - itens já estão no catálogo acima)
  adminSideMenuItens: [],

  // Menus do topo (perfil, etc)
  topMenuItens: [
    {
      key: '/profile',
      icon: <UserOutlined style={topMenuItensIconsStyle} />,
      title: displayMessage('MY_PROFILE'),
    },
  ],
};

export default menus;
